"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.mockAmbassadorDetail = exports.mockAmbassadorMini = void 0;
const test_helpers_1 = require("../test_helpers");
function mockAmbassadorMini(overrides = {}) {
    const id = +(0, test_helpers_1.incrementingId)();
    return {
        ambassador_code: 'test' + id,
        display_name: null,
        first_name: null,
        full_name: null,
        id: id,
        image: 'https://example.com/2305832095832958.jpg',
        last_name: null,
        role: 'ambassador_bronze',
        slug: 'user_profile_slug' + id,
        ...overrides,
    };
}
exports.mockAmbassadorMini = mockAmbassadorMini;
function mockAmbassadorDetail(overrides = {}) {
    const ambassadorMini = mockAmbassadorMini(overrides);
    return {
        banner_image: null,
        book_guide_url: null,
        brands: [],
        description: null,
        facebook: null,
        fishing_reports_count: null,
        followers_count: 0,
        instagram: null,
        lists: [],
        location: null,
        media_count: 0,
        organizations: [],
        species: [],
        tiktok: null,
        title: null,
        twitter: null,
        user_event_notifications: {
            new_fishing_report: false,
            new_article: false,
            frequency: 'weekly',
        },
        user_favorite: false,
        user: ambassadorMini,
        waterbodies: [],
        website: null,
        youtube_title: null,
        youtube: null,
        ...ambassadorMini,
        ...overrides,
    };
}
exports.mockAmbassadorDetail = mockAmbassadorDetail;
